import overrides from "theme/overrides"
import palette from "theme/palette"
import typography from "theme/typography"

export const muiTheme = {
  palette,
  overrides,
  typography,
}
